'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import styled from 'styled-components';
import { toolbarI18nKey, ToolbarControlTypes, controlPropType, textButtonStyles } from '../../constants/toolbar';
import Divider from './Divider';
import MoreMenu from './MoreMenu';
import Control from './Control';
import ToolbarMenu from './ToolbarMenu';
import { jsx as _jsx } from "react/jsx-runtime";
let dividerIndex = 0;
const getDividerIndex = () => {
  return ++dividerIndex;
};
const ControlGroupDiv = styled.div.withConfig({
  displayName: "ControlGroup__ControlGroupDiv",
  componentId: "nxagih-0"
})(["display:flex;flex-shrink:0;align-items:center;"]);
const StyledMoreMenu = styled(MoreMenu).withConfig({
  displayName: "ControlGroup__StyledMoreMenu",
  componentId: "nxagih-1"
})(["", ";"], textButtonStyles);
const StyledToolbarMenu = styled(ToolbarMenu).withConfig({
  displayName: "ControlGroup__StyledToolbarMenu",
  componentId: "nxagih-2"
})(["", ";"], textButtonStyles);
export default class ControlGroup extends Component {
  constructor(props) {
    super(props);
    this.renderControl = this.renderControl.bind(this);
  }
  getPrevControlType(index) {
    const {
      controls
    } = this.props;
    const prevControl = controls[index - 1];
    return prevControl ? prevControl.type : '';
  }
  updateControlRect(control) {
    return boundingRect => {
      this.props.collectControlRect(control, boundingRect);
    };
  }
  renderDivider() {
    return /*#__PURE__*/_jsx(Divider, {}, `divider-${getDividerIndex()}`);
  }
  renderControlButton(control, menuItems, index) {
    const {
      renderControl,
      name
    } = this.props.convertToButton(control);
    return /*#__PURE__*/_jsx(Control, {
      updateControlRect: this.updateControlRect(name),
      prevControlType: this.getPrevControlType(index),
      render: renderControl,
      contextualNodeAttributes: this.props.contextualNodeAttributes,
      menuItems: menuItems
    }, name);
  }
  renderMoreMenu(menuItems, index) {
    return /*#__PURE__*/_jsx(Control, {
      prevControlType: this.getPrevControlType(index),
      render: renderProps => /*#__PURE__*/_jsx(StyledMoreMenu, Object.assign({}, renderProps, {
        "data-test-id": "more-menu",
        dropdownClassName: this.props.dropdownClassName,
        menuItems: menuItems.map(this.props.convertToButton),
        onOpenComplete: this.props.onMoreMenuOpenComplete,
        toolbarWidth: this.props.toolbarWidth,
        updateControlRect: this.updateControlRect('moremenu'),
        controlRects: this.props.controlRects,
        contextualNodeAttributes: this.props.contextualNodeAttributes
      }))
    }, "more-menu");
  }
  renderInsertMenu(menuItems, index) {
    return /*#__PURE__*/_jsx(Control, {
      prevControlType: this.getPrevControlType(index),
      render: props => /*#__PURE__*/_jsx(StyledToolbarMenu, Object.assign({}, props, {
        "data-test-id": "insert-menu",
        dropdownClassName: this.props.dropdownClassName,
        menuItems: menuItems.map(this.props.convertToMenuItem),
        buttonText: I18n.text(toolbarI18nKey('insertMenu'))
      }))
    }, "insert-menu");
  }
  renderAdvancedMenu(menuItems, index) {
    return /*#__PURE__*/_jsx(Control, {
      prevControlType: this.getPrevControlType(index),
      render: props => /*#__PURE__*/_jsx(StyledToolbarMenu, Object.assign({}, props, {
        dropdownClassName: this.props.dropdownClassName,
        id: "advanced-menu",
        "data-test-id": "advanced-menu",
        menuItems: menuItems.map(this.props.convertToMenuItem),
        buttonText: I18n.text(toolbarI18nKey('advancedMenu'))
      }))
    }, "advanced-menu");
  }
  renderControl({
    control,
    type,
    menuItems
  }, index) {
    switch (type) {
      case ToolbarControlTypes.DIVIDER:
        return this.renderDivider();
      case ToolbarControlTypes.BUTTON:
      case ToolbarControlTypes.SELECT:
        return this.renderControlButton(control, menuItems, index);
      case ToolbarControlTypes.MORE_MENU:
        return this.renderMoreMenu(menuItems, index);
      case ToolbarControlTypes.INSERT_MENU:
        return this.renderInsertMenu(menuItems, index);
      case ToolbarControlTypes.ADVANCED_MENU:
        return this.renderAdvancedMenu(menuItems, index);
      default:
        return null;
    }
  }
  render() {
    const {
      controls
    } = this.props;
    return /*#__PURE__*/_jsx(ControlGroupDiv, {
      children: controls.map(this.renderControl)
    });
  }
}
ControlGroup.propTypes = {
  controls: PropTypes.arrayOf(controlPropType).isRequired,
  convertToButton: PropTypes.func.isRequired,
  convertToMenuItem: PropTypes.func.isRequired,
  toolbarWidth: PropTypes.number.isRequired,
  collectControlRect: PropTypes.func,
  dropdownClassName: PropTypes.string,
  onMoreMenuOpenComplete: PropTypes.func,
  controlRects: PropTypes.object,
  toolbarShepherdProps: PropTypes.object,
  contextualNodeAttributes: PropTypes.object
};